import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../../../../../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';

export const NameSubCategoryInput: React.FC = () => {
	const { changeNameOfSubCategory } = useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterSubcategoryName') }], [t]);

	return (
		<FormInput
			name="nameOfSubCategory"
			label="nameSubcategoryLabel"
			onChange={changeNameOfSubCategory}
			validationRules={validationRules}
		/>
	);
};
